import { render, staticRenderFns } from "./BookingSummarySectionTwo.vue?vue&type=template&id=fbae4e76&"
import script from "./BookingSummarySectionTwo.vue?vue&type=script&lang=js&"
export * from "./BookingSummarySectionTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports